import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Select, MenuItem, Typography } from '@mui/material';

// Tri-state dropdown floating filter for Yes/No (string-valued) AG Grid columns.
// Pair with `filter: 'agTextColumnFilter'` and a valueGetter returning 'Yes'|'No'.
const BooleanFloatingFilter = forwardRef((props, ref) => {
  const [value, setValue] = useState('');

  useImperativeHandle(ref, () => ({
    onParentModelChanged(parentModel) {
      setValue(parentModel?.filter ?? '');
    }
  }));

  const onChange = (e) => {
    const next = e.target.value;
    setValue(next);
    if (next === '') {
      props.onFloatingFilterChanged(null, null);
    } else {
      props.onFloatingFilterChanged('equals', next);
    }
  };

  return (
    <Select
      value={value}
      onChange={onChange}
      displayEmpty
      variant="outlined"
      size="small"
      sx={{
        width: '100%',
        height: 28,
        fontSize: '0.8rem',
        '& .MuiSelect-select': { py: 0.25, px: 1 },
        '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' }
      }}
      MenuProps={{ PaperProps: { sx: { fontSize: '0.85rem' } } }}
    >
      <MenuItem value="">
        <Typography variant="body2" color="text.secondary">All</Typography>
      </MenuItem>
      <MenuItem value="Yes">Yes</MenuItem>
      <MenuItem value="No">No</MenuItem>
    </Select>
  );
});

export default BooleanFloatingFilter;
